import { fetchWrapper, IBaseResponse, extractPaginationInfo } from './apiBase';
import { IRepository, IPagination, ICommit } from '@/types';
import { BASE_API_URL } from '@/config/environment';

export interface IRepositoryCommitsResponse extends IBaseResponse {
  commits?: ICommit[];
  pagination?: IPagination;
}

export interface IRepositoryCommitResponse extends IBaseResponse {
  commit?: ICommit;
}

const responseHandler = (data: IRepositoryCommitsResponse): IRepositoryCommitsResponse => {
  const { commits, status, status_message, error } = data;
  const pagination = extractPaginationInfo(data);
  return {
    status,
    status_message,
    commits,
    pagination,
    error: error || null,
  };
};

export const fetchRepositoryCommit = async (
  namespace: string,
  repositoryName: string,
  commitRef: string,
  token?: string,
): Promise<IRepositoryCommitResponse> => {
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/commits/${commitRef}`;

  return await fetchWrapper({
    resourceName: 'commit',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, commitRef },
  });
};

const emptyCommitResponse = {
  status: 'success',
  status_message: 'OK',
  commits: [],
  pagination: { total_entries: 0, page_number: 1, page_size: 1, total_pages: 1 },
  error: null,
};

export const fetchCommitHistory = async ({
  repository,
  resource,
  pageNumber = 1,
  pageSize = 1,
  token,
}: {
  repository: IRepository;
  resource: string;
  pageNumber?: number;
  pageSize?: number;
  token?: string;
}): Promise<IRepositoryCommitsResponse> => {
  const { namespace, name: repositoryName } = repository;
  if (repository.latest_commit === null) {
    return emptyCommitResponse as unknown as IRepositoryCommitsResponse;
  }
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/commits/history/${resource}?page_size=${pageSize}&page=${pageNumber}`;
  const data = await fetchWrapper({
    resourceName: 'commitHistory',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, resource },
  });
  return responseHandler(data);
};

export const getCommitCount = async (repository: IRepository, branchName: string, authToken?: string) => {
  const { pagination } = await fetchCommitHistory({
    repository,
    resource: branchName,
    token: authToken,
  });
  return pagination?.total_entries;
};
